// Copyright (c) 2017 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import File, {getDefaultState as getFileDefaultState} from './file';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import TimestampUser, {getDefaultState as getTimeStampUserDefaultState} from './timestamp-user';
import Rate from './rate';
import t from 'tcomb';

const LaborRate = t.struct({
    account: t.String,
    averageTechPayRate: t.maybe(t.Number),
    effectiveDate: t.maybe(t.Number),
    file: File,
    getForTcsm: t.Boolean,
    internalDeereComments: t.String,
    notesToDealer: t.String,
    overrideEffectiveDate: t.maybe(t.Number),
    rates: t.list(Rate),
    reasonForOverride: t.String,
    requestDate: t.maybe(t.Number),
    requestId: t.String,
    requestStatus: KeyValuePair,
    requestedBy: TimestampUser,
    responsibleAccount: Dealer,
    salesOffDiff: t.Boolean
}, {
    name: 'LaborRate',
    strict: true
});

export const getDefaultState = () => new LaborRate({
    account: '',
    averageTechPayRate: null,
    effectiveDate: null,
    file: getFileDefaultState(),
    getForTcsm: false,
    internalDeereComments: '',
    notesToDealer: '',
    overrideEffectiveDate: null,
    rates: [],
    reasonForOverride: '',
    requestDate: null,
    requestId: '',
    requestStatus: getKeyValuePairDefaultState(),
    requestedBy: getTimeStampUserDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    salesOffDiff: false
});

export default LaborRate;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/labor-rate.js